export default __webpack_public_path__ + "static/media/ebayListingDataExample.6c658c64.png";